import(/* webpackMode: "eager" */ "/app/app/(providers)/cardio-thoracic-surgery-detailpage/page.js");
